var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDice5 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M16.25 7.75h.005m-.005 8.5h.005M7.75 7.75h.005m4.245 4h.005m-4.255 4.5h.005M7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21m8.7-13.25a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0m0 8.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0M8 7.75a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0m4.25 4a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0M8 16.25a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0"
})));
export default SvgDice5;